import React from 'react';
import { useState, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';


import Modal from '../../../components/UI/Modal/Modal'
import API from '../../../lib/api';
import AuthContext from '../../store/auth-context';

import styles from './AuthForm.module.css';

const DemoLogin = () => {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const [isLogin, setIsLogin] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState( null );

  const submitHandler = ( event ) => {
    event.preventDefault();
    setIsLogin((prevState) => !prevState);
    authCtx.demoLogin();
    navigate('/submit/');
  };

  return (
    <section className={styles.auth}>
      { errorMsg && <Modal show={!!errorMsg}
          modalClosed={() => { setErrorMsg(null) }}
          className = 'error'>
           <div>{errorMsg}</div>
        </Modal>
      }
      <h1>Demo Login</h1>
      <form onSubmit={submitHandler}>
        <div className={styles.actions}>
            <button>Login</button>
        </div>
      </form>
    </section>
  );
};

export default DemoLogin;
